<ngx-spinner bdColor="rgba(76,76,76,0.7)" size="medium" color="#C71444" type="ball-spin">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<app-header></app-header>
<!-- <div class="container pl-0 pr-0">
  
  <hr>
</div> -->
<div class="container mb-3">
  <div class="row m-0 mt-2 border parent-container">
    <div class="col pt-1 padding-x-5">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<app-footer></app-footer>